import React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import isMobile from 'ismobilejs';


class DataCenter {
  constructor(){
    this.file = null;
    this.src = null;
    this.isMobile = isMobile.any;
    this.firestore = null;
    this.cropArea = {
      pos: {x: 0, y: 0},
      size: {width: 0, height: 0}
    };
    this.resizeLength = 220;

    this.listenFunc = {};

    //firebase
    const config = {
      apiKey: "AIzaSyAnLbASroXePkWwHYrkbWmQIJJBDxd-Ets",
      authDomain: "ms-meme.firebaseapp.com",
      databaseURL: "https://ms-meme.firebaseio.com",
      projectId: "ms-meme",
      storageBucket: "ms-meme.appspot.com",
      messagingSenderId: "859831533657"
    };
    firebase.initializeApp(config);
    this.storage = firebase.storage().ref();
    const firestore = firebase.firestore();
    const settings = {timestampsInSnapshots: true};
    firestore.settings(settings);
    this.firestore = firestore;
    this.now = firebase.firestore.FieldValue.serverTimestamp;
  }

  onChange(prop, func){
    this.listenFunc[prop] = this.listenFunc[prop] || [];
    this.listenFunc[prop].push(func);
  }

  set(prop, value){
    this[prop] = value;
    if (Array.isArray(this.listenFunc[prop])){
      this.listenFunc[prop].forEach(func => {
        func(value);
      });
    }
  }
}


const DataContext = React.createContext(null);


let withData = Component => props => (
  <DataContext.Consumer>
    {data => <Component data={data} {...props} />}
  </DataContext.Consumer>
);


export { DataCenter, DataContext, withData };


// WEBPACK FOOTER //
// ./src/utility/DataContext.js